export default __webpack_public_path__ + "assets/images/202949743b79176368da3d51ca4d4737.png";